module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_plus_white-a975dc2bda5c1f24f8082cb97a42b53f.svg";